/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import CloudIcon from '@material-ui/icons/Cloud';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import { grey } from '@material-ui/core/colors';

import useTimeline from '../timeline/useTimeline';

const sortingIconMap = {
  ASC: 'icon-sort-ascending icon-small',
  DESC: 'icon-sort-descending icon-small',
};

const cardItemRender = (
  item,
  activeClinicianId,
  activeClinicianPostingId,
  showClinicianDetailsClick,
  showClinicianTreatmensClick,
  isMileageCapEnabled,
  includeTreatments,
  activeTreatment,
) => {
  const clinician = item.cardDetails;
  const hasValidBasePostCode = item.source.hasValidBasePostCode;
  const hasMileageCap = item.source.hasMileageCap;
  const clinicianDetails = { ...item.source, assignments: [...item.activities.assignments] };
  const showExtraInformation = extraCondition => clinician.showExtraInfo && extraCondition;

  const containerClass = classNames({
    'timeline-card': true,
    'active-clinician': clinician.id === activeClinicianId && clinician.postingId === activeClinicianPostingId,
    'preferred-clinician':
      activeTreatment != null &&
      activeTreatment.preferredClinicianId === clinician.id &&
      activeTreatment.masterId === null,
  });

  return (
    <div key={clinician.index} className={containerClass}>
      <div className="timeline-cell">
        <Box display="flex">
          <Box
            onClick={() =>
              includeTreatments ? () => {} : showClinicianTreatmensClick(clinician.id, clinician.postingId)
            }
            className="timeline-card-body"
          >
            <Box display="flex" p={0}>
              <Box flexGrow={0} py={0.5}>
                <AddLocationIcon className={`rag-avatar rag-status-${clinician.cardRagStatus}`} />
              </Box>
              <Box display="flex" flexDirection="column" flexGrow={1} p={0.5} style={{ padding: '4px 0' }}>
                <Typography className="ellipsis" variant="h5" style={{ width: '140px' }}>
                  {clinician.personName}
                </Typography>
                <Typography className="ellipsis" variant="subtitle1" style={{ width: '140px' }}>
                  {clinician.bandName}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" px={0.5} alignItems="flex-end">
              <Box flexGrow={1} display="flex" alignItems="flex-end">
                {showExtraInformation(clinician.desc !== '') && (
                  <Typography variant="caption" style={{ color: clinician.descColor }}>
                    <span className="icon-extend icon-clock-in-out icon-small" />
                    <span
                      style={{ display: 'inline-block', verticalAlign: 'top', fontSize: '11px', paddingTop: '5px' }}
                    >
                      {clinician.desc}
                    </span>
                  </Typography>
                )}
              </Box>
              <Box display="flex" alignItems="center" flexGrow={0}>
                {showExtraInformation(clinician.isOnline) && (
                  <CloudIcon fontSize="small" style={{ color: grey[500] }} />
                )}
                {showExtraInformation(!clinician.isOnline) && (
                  <CloudOffIcon fontSize="small" style={{ color: grey[500] }} />
                )}
                {isMileageCapEnabled && hasValidBasePostCode && hasMileageCap && (
                  <span
                    className="icon-extend icon-radius icon-small"
                    style={{ color: grey[500], paddingLeft: '4px' }}
                  />
                )}
              </Box>
              &nbsp;
            </Box>
          </Box>
          <Box alignSelf="flex-end">
            <Box
              pr={0.5}
              size="small"
              aria-label="Dns"
              onClick={() => showClinicianDetailsClick(clinicianDetails)}
              style={{ cursor: 'pointer' }}
            >
              <span className="icon-extend icon-info-more icon-small" />
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  );
};

function CardItemsColumnHtml({ items, isMileageCapEnabled, includeTreatments }) {
  const { activeClinicianId, activeClinicianPostingId, activeTreatment, setFlagAndClinician } = useTimeline();
  const setShowClinicianDetails = clinician => {
    setFlagAndClinician(
      'showClinicianDetails',
      true,
      clinician.id,
      clinician.postingId,
      ['showClinicianTreatments', 'enableMultipleSelection'],
      clinician,
    );
  };
  const setShowClinicianTreatments = (clinicianId, postingId) => {
    setFlagAndClinician(
      'showClinicianTreatments',
      activeClinicianId !== clinicianId || activeClinicianPostingId !== postingId,
      clinicianId,
      postingId,
      ['showClinicianDetails', 'isEditMode', 'enableMultipleSelection'],
    );
  };

  return (
    <div className="tbody">
      {items.length ? (
        items.map(item =>
          cardItemRender(
            item,
            activeClinicianId,
            activeClinicianPostingId,
            setShowClinicianDetails,
            setShowClinicianTreatments,
            isMileageCapEnabled,
            includeTreatments,
            activeTreatment,
          ),
        )
      ) : (
        <div className="no-data-text">No clinician available</div>
      )}
    </div>
  );
}

const convertMinsToHrsMins = minutes => {
  let h = Math.floor(minutes / 60);
  let m = minutes % 60;
  h = h < 10 ? `0${h}` : h;
  m = m < 10 ? `0${m}` : m;

  return `${h}:${m}`;
};

const timelineGridHtml = hoursArray => {
  const timePeriodHours = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < hoursArray.length; i++) {
    const h = hoursArray[i];
    const formatedHour = `${h.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })}:00`;
    timePeriodHours.push(formatedHour);
  }

  return (
    <div className="head-hour-info">
      {timePeriodHours.map((hour, index) => (
        <div key={`hour_${index}`} className="head-hour">
          <div className="hourly-interval">{hour}</div>
        </div>
      ))}
    </div>
  );
};

const renderSchedulerHourRows = row => {
  if (row.dontRender) return null;
  const cssNames = row.isDirty ? 'timeline-hour warning' : 'timeline-hour';
  return (
    <div key={row.key} className="timeline-hour-wrapper timeline-cell">
      <div className={cssNames} />
    </div>
  );
};

const renderSchedulerHourColumns = (index, rows) => {
  return (
    <div key={index} className="timeline-row timeline-hour-row">
      {rows.map(renderSchedulerHourRows)}
    </div>
  );
};

const sortClinicianOptions = [
  {
    id: 1,
    propertyName: 'gradeEquivalence',
    label: 'Grade',
    name: (
      <span>
        ✓ Grade <i className={sortingIconMap.DESC} />
      </span>
    ),
    isAsc: false,
  },
  {
    id: 2,
    propertyName: 'personName',
    label: 'Name',
    name: 'Name',
    isAsc: true,
  },
  {
    id: 3,
    propertyName: 'cardRagStatusId',
    label: 'RAG',
    name: 'RAG',
    isAsc: true,
  },
];

const sortTreatmentOptions = [
  {
    id: 1,
    propertyName: 'ragStatus',
    label: 'RAG',
    name: (
      <span>
        ✓ RAG <i className={sortingIconMap.DESC} />
      </span>
    ),
    isAsc: false,
  },
  {
    id: 2,
    propertyName: 'patientName',
    label: 'Name',
    name: 'Name',
    isAsc: true,
  },
  {
    id: 3,
    propertyName: 'postcode',
    label: 'Postcode',
    name: 'Postcode',
    isAsc: true,
  },
  {
    id: 4,
    propertyName: 'band',
    label: 'Grade',
    name: 'Grade',
    isAsc: true,
  },
  {
    id: 5,
    propertyName: 'totalTime',
    label: 'Duration',
    name: 'Duration',
    isAsc: true,
  },
];

export {
  CardItemsColumnHtml,
  timelineGridHtml,
  convertMinsToHrsMins,
  renderSchedulerHourColumns,
  sortClinicianOptions,
  sortTreatmentOptions,
  sortingIconMap,
};
